import React, { Component } from 'react'
import { ah, sh, compose, ReduxWrapper, QueryWrapper } from 'common-data/datahelpers'
import {
  FormBox, FormBoxHeader, WizardBox, WizardBoxItem, Grid, GridCell,
  WizardBoxSteps, TextBox, RadioListBox, Button
} from 'common-controls/Core/index'
import { BuildMessageBusEvents } from 'common-tools/index'
import _ from 'common-tools/LodashHelper'
import styles from './RegisterDevice.less'
import clsx from 'clsx'

export const RegisterDeviceEvents = BuildMessageBusEvents('Login.RegisterDevice')

const formName = 'RegisterDevice'
const RegisterDeviceSteps = {
  EmailOrPhone: 'emailorphone',
  ConfirmCode: 'confirmcode',
  RememberDevice: 'rememberDevice',
  Confirm: 'confirm'
}
const stopAction = true
const allowAction = false

class RegisterDevicePlain extends Component {
  constructor (props) {
    super(props)

    this.state = {
      initialValues: {
      },
      RegisterDeviceCompletedSteps: []
    }
  }

  async componentDidMount () {
    const { GetVerificationChannels, formCheckForSubmissionErrors, formStopSubmit, SessionAccountKey } = this.props
    try {
      await GetVerificationChannels({ AccountKey: SessionAccountKey })
    } catch (err) {
      formCheckForSubmissionErrors(err, false)
      formStopSubmit(formName, err)
    }
  }

  onSubmit (values) {
    const { formCheckForSubmissionErrors, showSuccess, close,
      RegisterDevice, SessionAccountKey, SessionDeviceFingerPrint } = this.props

    if (values.IsTemporary === 'true') {
      showSuccess(`Awesome!!! This device has been verified.`)
      close([{ Type: RegisterDeviceEvents.Close }, { Type: RegisterDeviceEvents.Success }])
    } else {
      return RegisterDevice({
        AccountKey: SessionAccountKey,
        Name: SessionDeviceFingerPrint.UserAgent,
        FingerPrint: SessionDeviceFingerPrint.Id,
        Location: 'Houston Texas',
        Confirmed: true,
        ConfirmOTP: 'ABC1024',
        IsTemporary: values.IsTemporary,
        DeviceNickName: values.DeviceNickName

      })
        .then(({ data, extra }) => {
          showSuccess(`Awesome!!! You have successfully registered this device.`)
          close([{ Type: RegisterDeviceEvents.Close }, { Type: RegisterDeviceEvents.Success }])
        })
        .catch(formCheckForSubmissionErrors)
    }
  }

  async beforeStepAction (nextStep, previousStep, direction) {
    const { close, formDataRegisterDevice, ValidateChannel,
      ValidateChannelCode, formCheckForSubmissionErrors, SessionAccountKey, formSetValidation } = this.props
    const { RegisterDeviceCompletedSteps } = this.state

    switch (nextStep) {
      case WizardBoxSteps.Done:
        return allowAction
      case WizardBoxSteps.Cancel:
        close([{ Type: RegisterDeviceEvents.Close }])
        return allowAction
    }

    if (direction === 'previous') {
      return allowAction
    }

    if (direction === 'next' && _.includes(RegisterDeviceCompletedSteps, previousStep)) {
      return allowAction
    }

    let errors = {}

    switch (previousStep) {
      case RegisterDeviceSteps.EmailOrPhone:
        if (!formDataRegisterDevice.ChannelKey) {
          errors.ChannelKey = 'Please select a channel to receive the confrimation code'
          formSetValidation(formName, errors)
          return stopAction
        } else {
          try {
            await ValidateChannel({ AccountKey: SessionAccountKey, ChannelKey: formDataRegisterDevice.ChannelKey })
          } catch (err) {
            const ret = formCheckForSubmissionErrors(err, false) || {}
            formSetValidation(formName, ret.data || ret, ret.fields)
            return stopAction
            // formStopSubmit(formName, errors)
          }
        }
        this.setState({
          RegisterDeviceCompletedSteps: _.uniq(_.concat(RegisterDeviceCompletedSteps, previousStep))
        })
        return allowAction

      case RegisterDeviceSteps.ConfirmCode:
        if (!formDataRegisterDevice.ConfirmCode) {
          errors.ConfirmCode = 'Please type a valid code'
          formSetValidation(formName, errors)
          return stopAction
        } else {
          try {
            await ValidateChannelCode({ AccountKey: SessionAccountKey, ChannelKey: formDataRegisterDevice.ChannelKey, VerificationCode: formDataRegisterDevice.ConfirmCode })
          } catch (err) {
            const ret = formCheckForSubmissionErrors(err, false) || {}
            formSetValidation(formName, ret.data || ret, ret.fields)
            return stopAction
            // formStopSubmit(formName, errors)
          }
        }
        this.setState({
          RegisterDeviceCompletedSteps: _.uniq(_.concat(RegisterDeviceCompletedSteps, previousStep))
        })
        return allowAction
      case RegisterDeviceSteps.RememberDevice:
        if (formDataRegisterDevice.IsTemporary === 'false' && !formDataRegisterDevice.DeviceNickName) {
          errors.DeviceNickName = 'Please type a device nickname'
          formSetValidation(formName, errors)
          return stopAction
        }
        this.setState({
          RegisterDeviceCompletedSteps: _.uniq(_.concat(RegisterDeviceCompletedSteps, previousStep))
        })
        return allowAction
    }
  }

  afterStepAction (nextStep, previousStep, direction) { }

  renderEmailOrPhone (data) {
    const channels =
      _.map(data.GetVerificationChannelsResults
        , (email) => {
          return { Value: email._key, Text: email.Data }
        })

    return (
      <React.Fragment>
        <Grid>
          <GridCell className={clsx('text-center')}>
            <h1>{`Hmm! Looks like you are signing in from a new device.`}</h1>
          </GridCell>
        </Grid>
        <Grid>
          <GridCell className={clsx('text-center')}>
            < FormBoxHeader title={`Let's help you register this device.`} />
          </GridCell>
        </Grid>
        <Grid>
          <GridCell className={clsx('text-center')}>
            <h2>Where will you like us to send the confirmation code?</h2>
          </GridCell>
        </Grid>
        <Grid paddingX className={'align-center'}>
          <GridCell className={styles.selectOptions}>
            <RadioListBox data-tid='channel' inline
              name='ChannelKey' options={channels} />
          </GridCell>
        </Grid>

      </React.Fragment>
    )
  }

  renderConfirmCode (formDataRegisterDevice) {
    return (
      <React.Fragment>
        <Grid>
          <GridCell className={clsx('text-center')}>
            <h1>Please enter the code sent to you</h1>
          </GridCell>
        </Grid>
        <Grid paddingX className={'align-center'}>
          <GridCell medium={6}>
            <TextBox data-tid='confirmCode' name="ConfirmCode" placeHolder="Confirmation Code" />
          </GridCell>
        </Grid>
      </React.Fragment>
    )
  }

  renderConfirmation (formSubmit, loading) {
    return (
      <React.Fragment>
        <Grid>
          <GridCell className={clsx('text-center')}>
            <h1>{`You are about to register your device.`}</h1>
            <h1>{`Click on the next to complete device registration`}</h1>
          </GridCell>
        </Grid>
        <Grid paddingX className={'align-center'}>
          <GridCell className={clsx('text-center')}>
            <Button loading={loading} color="primary" size="lg" block onClick={() => { formSubmit(formName) }}>Register My Device</Button>
          </GridCell>
        </Grid>
      </React.Fragment>
    )
  }

  renderRememberDevice (formData) {
    return (
      <React.Fragment>
        <Grid>
          <GridCell className={clsx('text-center')}>
            <h1>{`Do you want MRx to remember this device?`}</h1>
          </GridCell>
        </Grid>
        <Grid paddingX className={clsx('align-center')}>
          <GridCell className={styles.selectOptions}>
            <RadioListBox data-tid='rememberList' inline
              name='IsTemporary'
              options={[{ Text: 'Remember this device (Recommended)', Value: 'false' }, { Text: 'Do NOT Remember this device', Value: 'true' }]} />
          </GridCell>
        </Grid>
        {formData.IsTemporary === 'false'
          ? <>
            <Grid paddingX className={clsx('align-center')}>
              <GridCell className={clsx('text-center')}>
                <h2>{`Give this device a nickname`}</h2>
              </GridCell>
            </Grid>
            <Grid paddingX className={clsx('align-center')}>
              <GridCell medium={6} className={clsx('text-center')}>
                <TextBox name="DeviceNickName" placeHolder="NickName" />
              </GridCell>
            </Grid>
            </>
          : null
        }
      </React.Fragment>
    )
  }

  render () {
    const { initialValues } = this.state //, RegisterDeviceCompletedSteps = []
    const { formDataRegisterDevice, data = {}, formSubmit } = this.props
    const { loadingDeviceRegistration = false } = data
    return (
      <FormBox form={formName} simpleBody initialValues={initialValues} onSubmit={this.onSubmit} onChange={this.onChange}>
        <WizardBox afterStepAction={this.afterStepAction} beforeStepAction={this.beforeStepAction} hideNextStepButton={false}
          defaultStepId={RegisterDeviceSteps.EmailOrPhone}>
          <WizardBoxItem stepId={RegisterDeviceSteps.EmailOrPhone} icon="envelope-square" nextStepId={RegisterDeviceSteps.ConfirmCode}>
            {this.renderEmailOrPhone(data)}
          </WizardBoxItem>
          <WizardBoxItem stepId={RegisterDeviceSteps.ConfirmCode} icon="key" nextStepId={RegisterDeviceSteps.RememberDevice}
            previousStepId={RegisterDeviceSteps.EmailOrPhone}>
            {this.renderConfirmCode(formDataRegisterDevice)}
          </WizardBoxItem>
          <WizardBoxItem stepId={RegisterDeviceSteps.RememberDevice} icon="tablet-alt" nextStepId={RegisterDeviceSteps.Confirm}
            previousStepId={RegisterDeviceSteps.ConfirmCode}>
            {this.renderRememberDevice(formDataRegisterDevice)}
          </WizardBoxItem>
          <WizardBoxItem stepId={RegisterDeviceSteps.Confirm} icon="check-circle" nextStepId={WizardBoxSteps.Done}
            previousStepId={RegisterDeviceSteps.RememberDevice}>
            {this.renderConfirmation(formSubmit, loadingDeviceRegistration)}
          </WizardBoxItem>
        </WizardBox>
      </FormBox>
    )
  }
}

export const RegisterDevice = compose(
  ReduxWrapper([
    sh.SessionToken,
    sh.SessionAccount,
    sh.FormData(formName, 'formDataRegisterDevice'),
    sh.SessionDeviceFingerPrint
  ], [
    ah.sendToURL,
    ah.setAppState,
    ah.formCheckForSubmissionErrors,
    ah.setAccount,
    ah.formSetFieldValue,
    ah.formStopSubmit,
    ah.formSubmit,
    ah.showSuccess,
    ah.formStopSubmit,
    ah.formSetValidation
  ]),
  QueryWrapper({
    key: formName,
    actions: [
      {
        url: '/Services/Profile/Channel/GetVerificationChannels',
        prop: 'GetVerificationChannels',
        map: 'GetVerificationChannelsResults'
      },
      {
        url: '/Services/Profile/Devices/RegisterDevice',
        prop: 'RegisterDevice',
        map: false
      },
      {
        url: '/Services/Security/Shared/ValidateChannel',
        prop: 'ValidateChannel',
        map: 'ValidateChannelResult'
      },
      {
        url: '/Services/Security/Shared/ValidateChannelCode',
        prop: 'ValidateChannelCode',
        map: 'ValidateChannelCodeResult'
      }
    ]
  })
)(RegisterDevicePlain)

export default RegisterDevice
